var map = {
	"./MAX-E_170.png": 811,
	"./MAX_NANO.png": 135,
	"./MAX_NANO_Peninsula.png": 871,
	"./baby_compare_hero.png": 545,
	"./babycompare_desktop_img.png": 65,
	"./collapse-btn.svg": 964,
	"./large_models.png": 242,
	"./popular_models.png": 593,
	"./single_star.svg": 767,
	"./star.svg": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;